import { CSSObject } from '@emotion/react';
import React, { ReactNode } from 'react';
import Select from 'react-select';

import {
  CmFormControl,
  CmFormLabel,
  MultipleReactSelectInput,
} from '@/components/uiParts';
import { reactSelectStyle } from '@/components/uiParts/Form/Select/ReactSelect/style';
interface Props {
  fontWeight?: 'bold' | 'normal';
  width?: string;
  name: string;
  label: string;
  selectInput: MultipleReactSelectInput;
  error?: ReactNode;
  isRequired?: boolean;
  isInvalid?: boolean;
  isOptionScroll?: boolean;
}

export const CmLabelAndMultipleReactSelect: React.VFC<Props> = ({
  fontWeight = 'normal',
  width = '100%',
  name,
  label,
  selectInput,
  error,
  isRequired = false,
  isInvalid = false,
  isOptionScroll = false,
}) => {
  const styles = {
    valueContainer: (baseStyles: CSSObject) => {
      const scrollStyle = isOptionScroll
        ? { maxHeight: '4rem', overflow: 'scroll', 'overflow-x': 'hidden' }
        : undefined;
      return {
        ...baseStyles,
        ...scrollStyle,
      };
    },
    ...reactSelectStyle,
  };
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabel {...{ isRequired, fontWeight }}>{label}</CmFormLabel>
      <Select
        className={`react-select ${isInvalid ? 'is-error' : ''}`}
        isMulti
        closeMenuOnSelect={false}
        name={name}
        {...{ ...selectInput, styles }}
      />
      {error}
    </CmFormControl>
  );
};
